import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

export default function FadeUp({ children, delay = 0, style = {}, className = '' }) {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(24px)',
        transition: `opacity 0.6s ${delay}ms, transform 0.6s ${delay}ms`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
